import { useReactiveVar } from '@apollo/client';
import { FC, useCallback } from 'react';

import { show2FaModal } from '../../../store/vars';
import { TwoFaModal } from '../TwoFaModal';

export const CommonComponents: FC = () => {
  const is2FaModalShown = useReactiveVar(show2FaModal);

  const close2FaModal = useCallback(() => {
    show2FaModal(false);
  }, []);

  return (
    <>
      <TwoFaModal open={is2FaModalShown} onClose={close2FaModal} />
    </>
  );
};
